// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-wrapper[data-v-75ebef39]{padding:2rem;background-color:#fff}@media screen and (min-width:576px){.panel-wrapper[data-v-75ebef39]{border-radius:8px;box-shadow:1px 2px 3px #d6d1d1;overflow:hidden}}", ""]);
// Exports
module.exports = exports;
